import React from 'react';
import { appUrl, companyName } from '../../../utils';

export default function Footer() {
  return (
    <footer className="footer-custom py-5" style={{ backgroundColor: '#000000' }}>
      <div className="container">
        <div className="row mb-5">
          {/* Brand */}
          <div className="col-12 col-md-4">
            <h5 className="fw-bold mb-3 text-white">{companyName()}</h5>
            <p className="text-secondary" style={{ fontSize: '14px' }}>
              La plataforma líder en venta de entradas para eventos en América Latina.
            </p>
            <div className="d-flex gap-3 mb-4">
              <a href={appUrl({ url: 'instagram' })} className="social-icon">
                <i className="fab fa-instagram"></i>
              </a>
              <a href={appUrl({ url: 'facebook' })} className="social-icon">
                <i className="fab fa-facebook"></i>
              </a>
              <a href={appUrl({ url: 'tiktok' })} className="social-icon">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href={appUrl({ url: 'twitter' })} className="social-icon">
                <i className="fab fa-x-twitter"></i>
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="col-12 col-md-4">
            <h6 className="fw-bold mb-3 text-white">CONÓCENOS</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href={appUrl({ url: 'nosotros' })} className="text-decoration-none text-secondary">
                  Acerca de nosotros
                </a>
              </li>
              <li className="mb-2">
                <a href={appUrl({ url: 'terminos-y-condiciones' })} className="text-decoration-none text-secondary">
                  Términos y condiciones
                </a>
              </li>
              <li className="mb-2">
                <a href={appUrl({ url: 'politica-de-cookies' })} className="text-decoration-none text-secondary">
                  Política de cookies
                </a>
              </li>
              <li className="mb-2">
                <a href={appUrl({ url: 'politica-de-privacidad' })} className="text-decoration-none text-secondary">
                  Política de privacidad
                </a>
              </li>
              <li className="mb-2">
                <a href={appUrl({ url: 'contacto' })} className="text-decoration-none text-secondary">
                  Contáctanos
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="col-12 col-md-4">
            <h6 className="fw-bold mb-3 text-white">¡TRABAJEMOS JUNTOS!</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href={appUrl({ url: 'contacto' })} className="text-decoration-none text-secondary">
                  ¿Tienes un evento?
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-top pt-4 text-center text-secondary" style={{ fontSize: '13px', borderTopColor: 'rgba(255,255,255,0.1)' }}>
          <p className="mb-0">© 2025 {companyName()}. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
